import { navigate } from 'gatsby'

import { QACategory, QAHeader, QAPanel, values } from '@karakuri-web/faq-component'
import { CategoryLayout, CategorySub } from '@karakuri-web/faq-type'

import { Data } from './interface'

interface Props {
  layout: CategoryLayout
  data: Data
}
export function CategoryWidget({ layout, data }: Props) {
  const categories = values(data.settingYaml.categories, [])
  if (!categories || categories.length === 0) {
    return null
  }
  const hashId =
    typeof window !== 'undefined' &&
    !!window.location &&
    !!window.location.pathname &&
    window.location.pathname.substring(10).replaceAll('/', '')
  const expandable = (c: CategorySub | null): boolean =>
    hashId === c?.id || (c?.sub || []).some(s => expandable(s))
  const isSelected = (id: string) => hashId === id

  const handleCategoryClick = (path: string) =>
    navigate(path.indexOf('category/') === 0 ? `/${path}` : path)

  return (
    <QAPanel className="faq-panel-category">
      <QAHeader title={layout.title || 'カテゴリから探す'} />
      {categories.map(category => (
        <QACategory
          key={category.id || ''}
          id={category.id || ''}
          title={category.title}
          sub={category.sub}
          isSelected={isSelected}
          expand={expandable(category)}
          checker={expandable}
          onCategoryClick={handleCategoryClick}
          moveToCategoryPageOnCategoryClick={
            data.settingYaml.useMoveToCategoryPageOnClickCategory || false
          }
        />
      ))}
    </QAPanel>
  )
}
